<template>
  <!-- 修改密码 -->
  <el-dialog
    :title="$t('omission.text43')"
    :visible.sync="dialogVisible"
    width="650px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
  <div class="change-password">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="auto"
      class="demo-ruleForm"
      label-position="top"
    >
      <!-- 原密码 -->
      <el-form-item :label="$t('omission.text44')" prop="oldPassword">
        <el-input v-model="ruleForm.oldPassword" show-password></el-input>
      </el-form-item>
      <!-- 新密码 -->
      <el-form-item :label="$t('omission.text45')" prop="newPasswordTest">
        <el-input v-model="ruleForm.newPasswordTest" show-password></el-input>
      </el-form-item>
      <!-- 确定新密码 -->
      <el-form-item :label="$t('omission.text46')" prop="newPassword">
        <el-input v-model="ruleForm.newPassword" show-password></el-input>
      </el-form-item>
      <el-form-item>
        <!-- 确认修改 -->
        <el-button
          class="btn"
          :disabled="
            this.ruleForm.oldPassword == '' ||
            this.ruleForm.newPasswordTest == '' ||
            this.ruleForm.newPassword == ''
          "
          type="primary"
          @click="submit()"
          >{{ $t("omission.text47") }}</el-button
        >
        <!-- 取消修改 -->
        <div class="cancelBtn">
        <el-button class="cancel" type="primary" @click="handleClose()">{{
          $t("omission.text48")
        }}</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
  </el-dialog>
</template>

<script>
import { oldPsw, newPsw,confirmPsw } from "../../utils/util/test";
export default {
  data() {
    return {
      ruleForm: {
        oldPassword: "", //原密码
        newPasswordTest: "", //新密码
        newPassword: "", //确认新密码
      },
      //验证
      rules: {
        oldPassword: [{ validator: oldPsw, trigger: "blur" }],
        newPasswordTest: [{ validator: newPsw, trigger: "blur" }],
        newPassword: [{ validator: confirmPsw, trigger: "blur" }],
      },
    };
  },
  props: ["dialogVisible"],
  methods: {
    //确认修改
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        let that = this;
        if (valid) {
          let str = {
            oldPassword: this.ruleForm.oldPassword,
            newPassword: this.ruleForm.newPassword,
          };
          this.request
            .resetSelfPassword(str)
            .then(() => {
              this.$message.success(that.$t("omission.text49"));
              setTimeout(() => {
                this.$router.push({ path: "/login" });
              }, 1000);
            })
            .catch(() => {});
        }
      });
    },
    //取消修改
    handleClose() {
      this.ruleForm = {
        oldPassword: "", //原密码
        newPasswordTest: "", //新密码
        newPassword: "", //确认新密码
      };
      this.$refs["ruleForm"].resetFields();
      this.$emit("dialogClose");
    },
  },
};
</script>

<style scoped>
.change-password {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.demo-ruleForm {
  width: 340px;
}

.btn {
  width: 100%;
  margin-top: 10px;
  border-radius: 15px;
}
.cancelBtn{
  margin: 20px 0 0 0 ;
}
.cancel {
  width: 100%;
  border-radius: 15px;
}
.title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}
</style>